import vars from '../helpers';

const home = ($obj) => {
	const $home = vars.$document.find('.js-home');

	const $linesToRight = vars.$document.find('.js-line-to-right');
	const $linesToBottom = vars.$document.find('.js-line-to-bottom');

	const $title1 = $home.find('.js-home-title-1');
	const $title2 = $home.find('.js-home-title-2');

	const $lead = $home.find('.js-home-lead');

	const $link1 = $home.find('.js-home-link-1');
	const $link2 = $home.find('.js-home-link-2');

	const $image1 = $home.find('.js-home-image-1');
	const $image2 = $home.find('.js-home-image-2');
	const $image3 = $home.find('.js-home-image-3');
	const $image4 = $home.find('.js-home-image-4');
	const $image5 = $home.find('.js-home-image-5');
	const $image6 = $home.find('.js-home-image-6');
	const $image7 = $home.find('.js-home-image-7');
	const $image8 = $home.find('.js-home-image-8');
	const $image9 = $home.find('.js-home-image-9');

	const $homeAnimationObjects = vars.$document.find('.js-home-animation-obj');

	$obj
		.from([$title1, $title2], {
			onStart() {
				$homeAnimationObjects.removeClass('is-hidden-desktop');
			},
			opacity: 0,
			x: vars.getDelta(-45),
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 1)
		.from($linesToRight, {
			x: '-100%',
			duration: 1,
			ease: 'none',
			clearProps: 'all',
		}, 1)
		.from($lead, {
			opacity: 0,
			y: vars.getDelta(45),
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 1.5)
		.from($linesToBottom, {
			// y: '-100%',
			height: 0,
			duration: 0.5,
			ease: 'none',
			clearProps: 'all',
		}, 2)
		.from($link1, {
			opacity: 0,
			y: vars.getDelta(-45),
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 2)
		.from($link2, {
			opacity: 0,
			x: vars.getDelta(45),
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 2.5)
		.from([$image5, $image6], {
			opacity: 0,
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 2.5)
		.from([$image2, $image4, $image7], {
			opacity: 0,
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 3)
		.from([$image1, $image3, $image8, $image9], {
			opacity: 0,
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 3.5)
	;
};

const start = ($obj) => {
	const $game = vars.$document.find('.js-game');

	const $back = vars.$document.find('.js-back');

	const $title1 = $game.find('.js-start-title-1');
	const $title2 = $game.find('.js-start-title-2');
	const $lead = $game.find('.js-start-lead');
	const $button = $game.find('.js-start-button');
	const $image = $game.find('.js-start-image');

	$obj
		.from($title1, {
			opacity: 0,
			x: vars.getDelta(-45),
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 1)
		.from($back, {
			opacity: 0,
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 1)
		.from($title2, {
			opacity: 0,
			x: vars.getDelta(45),
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 1)
		.from($lead, {
			opacity: 0,
			y: vars.getDelta(45),
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 1.5)
		.from($button, {
			opacity: 0,
			x: vars.getDelta(-45),
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 2)
		.from($image, {
			opacity: 0,
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 2.5)
	;
};

const step = ($obj) => {
	const $game = vars.$document.find('.js-game');

	const $line1 = $game.find('.js-step-line-1');
	const $line2 = $game.find('.js-step-line-2');
	const $line3 = $game.find('.js-step-line-3');
	const $check = $game.find('.js-step-check');
	const $text = $game.find('.js-slide[data-slide="1"] .js-step-text');
	const $button = $game.find('.js-step-button');
	const $images = $game.find('.js-slider-image[data-slide="1"]');

	vars.gsapCleaner($text);

	$obj
		.from([$line1, $line2], {
			height: 0,
			duration: 1.5,
			ease: 'none',
			clearProps: 'all',
		}, 1)
		.from($line3, {
			width: 0,
			duration: 0.5,
			ease: 'none',
			clearProps: 'all',
		}, 1.5)
		.from($check, {
			opacity: 0,
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 1)
		.from($text, {
			opacity: 0,
			y: vars.getDelta(-15),
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 1.5)
		.from($button, {
			opacity: 0,
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 2)
		.from($images, {
			opacity: 0,
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 2.5)
	;
};

const article = ($obj) => {
	const $back = vars.$document.find('.js-back');

	$obj
		.from($back, {
			opacity: 0,
			duration: 0.75,
			ease: 'none',
			clearProps: 'all',
		}, 0.5)
	;
};

export default {
	home,
	start,
	step,
	article,
};
